/**
 * Utility functions for handling image URLs
 */

// Get the backend base URL for images
const getBackendBaseURL = (): string => {
  // In development, use localhost
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5002';
  }
  // In production, use the same domain
  return 'https://www.crmonce.com';
};

/**
 * Fix image URL by prepending the backend base URL
 * @param imagePath - The image path from the database (e.g., '/uploads/blogs/filename.jpg')
 * @returns The full URL to the image
 */
export const fixImageURL = (imagePath: string | null | undefined): string => {
  if (!imagePath) {
    // Return a default placeholder image
    return 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=800&h=400&fit=crop';
  }

  // If it's already a full URL, return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // If it starts with /uploads, prepend the backend URL
  if (imagePath.startsWith('/uploads/')) {
    return `${getBackendBaseURL()}${imagePath}`;
  }

  // If it doesn't start with /, assume it's a relative path and add /uploads/blogs/
  if (!imagePath.startsWith('/')) {
    return `${getBackendBaseURL()}/uploads/blogs/${imagePath}`;
  }

  // Default case: prepend backend URL
  return `${getBackendBaseURL()}${imagePath}`;
};

/**
 * Fix author avatar URL
 * @param avatarPath - The avatar path from the database
 * @returns The full URL to the avatar
 */
export const fixAvatarURL = (avatarPath: string | null | undefined): string => {
  if (!avatarPath) {
    // Return a default avatar
    return 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face';
  }

  // If it's already a full URL, return as is
  if (avatarPath.startsWith('http://') || avatarPath.startsWith('https://')) {
    return avatarPath;
  }

  // For relative paths, prepend the backend URL
  return `${getBackendBaseURL()}${avatarPath}`;
};
